import { liveQuoteTradeApiConnector } from 'apiConnector/secondary-market/live/trade';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { secondaryMarketLiveInstantBookWorkflowReceived } from 'state/secondaryMarket/live/instantBook/instantBook.actions';
import { liveInstantBookErrorsThunk } from 'state/secondaryMarket/live/instantBook/instantBook.thunks';
import type { EpicWithThunk } from 'state/state.common';
import type { HttpError } from 'utils/http/httpClient.model';

export function bookLiveTradeEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient, frontLogger }) =>
    actions$.pipe(
      ofType('SECONDARY_MARKET_LIVE_INSTANT_BOOK_REQUESTED'),
      mergeMap(({ orderId }) => {
        return liveQuoteTradeApiConnector(httpClient)
          .bookTrade(orderId)
          .pipe(
            map(() => secondaryMarketLiveInstantBookWorkflowReceived(orderId)),
            catchError((error: HttpError) => {
              frontLogger.error('An error occurred inside bookLiveTradeEpic {@FrontError}', error);
              return of(liveInstantBookErrorsThunk(orderId, error));
            }),
          );
      }),
    );
}
